import { specialistGroups } from './constants'

const specialistsExist = (group: string): boolean =>
  specialistGroups.some((g) => g === group)

export default specialistsExist
